module.exports = __webpack_public_path__ + "img/area-limit-btn-disabled.3f8b7c14.png";